import type { NativeCalibrationHint } from 'shared/lib/tv-game/nativeFrame.ts';

/**
 * Shared across the preparation/calibration screens of every game **except catch-pose**.
 * `null` → no alert. Set from each game's display engine when `frame.calibration` arrives,
 * cleared (set to `null`) when it goes away or the game leaves the preparation phase.
 */
let snapshot: NativeCalibrationHint | null = null;
const listeners = new Set<() => void>();

export function getCalibrationAlertSnapshot(): NativeCalibrationHint | null {
  return snapshot;
}

export function subscribeCalibrationAlert(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  return () => listeners.delete(onStoreChange);
}

export function setCalibrationAlert(next: NativeCalibrationHint | null): void {
  if (snapshot === next) return;
  snapshot = next;
  listeners.forEach((l) => l());
}
